module.exports = __webpack_public_path__ + "static/media/16.1c364267.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/16.png
// module id = 1056
// module chunks = 0